/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    /** Represents the StartComponent */
    Start = "start",
};
